__turbopack_context__.v({
  "banner": "AddToCartErrorBanner-module-scss-module__rFNmQq__banner",
});
